import { FileUrl } from 'models/dtos'
import { VehicleDocument } from 'models'

type ResolvedDocument = {
  document: VehicleDocument
  url: string | null
}

const getDocumentsFileStorageIds = (documents: Array<VehicleDocument> = []) =>
  documents
    .map((doc) => doc.fileStorageId)
    .filter((id): id is string => Boolean(id && id.trim().length > 0))

const resolveDocumentsUrls = (
  documents: Array<VehicleDocument> = [],
  idsAndUrls: Array<FileUrl> = [],
): Array<ResolvedDocument> => {
  const urlMap = new Map(idsAndUrls.map(({ id, url }) => [id, url]))

  return documents.map((document) => {
    if (document.fileStorageId) {
      return {
        document,
        url: urlMap.get(document.fileStorageId) ?? null,
      }
    }

    return {
      document,
      url: document.url ?? null,
    }
  })
}

export type { ResolvedDocument }
export { resolveDocumentsUrls, getDocumentsFileStorageIds }
